import React from 'react';
import PerformanceTabs from './components/tabs';
import './performanceDashboard.css';
import { Loading, SystemText } from 'e4shared';
import PageHeader from 'components/general/pageHeader';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';

export const PerformanceDashboard = ({ history, profile, buttons }) => {
    const [loaded, setLoaded] = React.useState(false);
    const st = (path, ...rest) => SystemText(`PerformanceDashboard/${path}`, ...rest);
    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        if (profile && user) {
            const { prism_UI } = user.companySettings;

            if (prism_UI) {
                history.replace(`/welcome/${profile.id}`);
            }

            setLoaded(true);
        }
    }, [profile, user]);

    const text = {
        focus: {
            title: st('Focus/Title'),
            allCaughtUp: st('Focus/AllCaughtUp'),
        },
        explore: st('Explore'),
        pathways: ps => st('Pathways', ps),
        tabs: {
            behaviour: st('Tabs/Behaviour'),
            metric: st('Tabs/Metric'),
            all: st('Tabs/All'),
            benchmark: st('Tabs/Benchmark'),
            filter: st('Tabs/Filter'),
            benchmarkTeam: st('Tabs/BenchmarkTeam'),
            filters: {
                capabilities: st('Tabs/Filters/Capabilities'),
                objectives: st('Tabs/Filters/Objectives'),
                objectivesUpcoming: st('Tabs/Filters/Objectives/Upcoming'),
                objectivesOverdue: st('Tabs/Filters/Objectives/Overdue'),
                scores: st('Tabs/Filters/Scores'),
                flagged: st('Tabs/Filters/Flagged'),
            },
        },
        behaviours: {
            title: st('Behaviours/Title'),
            help: st('Behaviours/Help'),
            noResults: st('Behaviours/NoResults'),
            card: {
                continue: st('Behaviours/Card/Continue'),
                explore: st('Behaviours/Card/Explore'),
                flag: {
                    areaForAttention: st('Behaviours/Card/Flag/AreaForAttention'),
                    addFlag: st('Behaviours/Card/Flag/AddFlag'),
                    removeFlag: st('Behaviours/Card/Flag/RemoveFlag'),
                },
                explore: st('Behaviours/Card/Explore'),
                rating: st('Behaviours/Card/Rating'),
                addObjective: st('Behaviours/Card/AddObjective'),
                objectives: st('Behaviours/Card/Objectives'),
            },
            overtime: {
                title: st('Behaviours/Overtime/Title'),
                close: st('Behaviours/Overtime/Close'),
                axis: {
                    rating: st('Behaviours/Overtime/Axis/Rating'),
                    rated: st('Behaviours/Overtime/Axis/Rated'),
                },
                noData: st('Behaviours/Overtime/NoData'),
            },
        },
        metrics: {
            title: st('Metrics/Title'),
            tooltip: st('Metrics/Tooltip'),
            behaviours: st('Metrics/Behaviours'),
            noResults: st('Metrics/NoResults'),
            noMetrics: st('Metrics/NoMetrics'),
            tabs: {
                goals: st('Metrics/Tabs/Goals'),
                motivators: st('Metrics/Tabs/Motivators'),
            },
            table: {
                myMetrics: st('Metrics/Table/MyMetrics'),
                benchmark: st('Metrics/Table/Benchmark'),
                overtime: st('Metrics/Table/MetricOvertime'),
                breakdown: st('Metrics/Table/Breakdown'),
                realtime: st('Metrics/Table/Realtime'),
                lastUpdated: x => st('Metrics/Table/LastUpdated', x),
                showBehaviours: x => st('Metrics/Table/ShowBehaviours', x),
            },
        },
        all: {
            noResults: {
                title: st('All/NoResults/Title'),
                message: st('All/NoResults/Message'),
            },
            card: {
                competencyOvertime: st('All/Card/CompetencyOvertime'),
            },
        },
        goals: {
            none: {
                you: st('Goals/None/You'),
                them: name => st('Goals/None/Them', name),
            },
            title: st('Goals/Title'),
            edit: st('Goals/Edit'),
            success: st('Goals/Success'),
            buttons: {
                save: st('Goals/Buttons/Save'),
                cancel: st('Goals/Buttons/Cancel'),
            },
            field: {
                label: st('Goals/Field/Label'),
                placeholder: st('Goals/Field/Placeholder'),
                help: st('Goals/Field/Help'),
            },
        },
    };

    if (!loaded) return <Loading />;

    return (
        <div data-testid="performance-dashboard" className="performance-dashboard" id="performance-dashboard">
            <PageHeader
                testId="121s-page-header"
                title={SystemText('User121/Title')}
                overrideProfile={profile ? profile : null}
                extra={buttons}
                homepage
            />
            <section className="content mtm10" data-testid="121-content">
                <PerformanceTabs text={text} profile={profile} />
            </section>
        </div>
    );
};

export default withRouter(PerformanceDashboard);
